import React from "react";
import { Redirect, Route, Switch } from "polyrouter";
import TableView from "./List/TableView";
import MapView from "./List/MapView";
import DeviceDetailsRouter from "./View/DeviceDetailsRouter";
import { useSelector } from "react-redux";
import { State } from "store";
import { InventoryView } from "generated/graphql";

export enum ViewValues {
  Map = "map",
  Table = "table"
}

const Devices: React.FC = () => {
  const { defaultInventoryView, inventorySessionState } = useSelector(
    (state: State) => {
      return state.userMeta;
    }
  );

  let routeTo = defaultInventoryView === InventoryView.List ? "/table" : "/map";
  if (inventorySessionState) {
    routeTo = inventorySessionState === InventoryView.List ? "/table" : "/map";
  }

  return (
    <Switch>
      <Route nest path="/map" component={MapView} />
      <Route nest path="/table" component={TableView} />
      <Route nest path="/details/:deviceId" component={DeviceDetailsRouter} />
      <Redirect nest to={routeTo} />
    </Switch>
  );
};

export default Devices;
